import {
  GET_TRAINING_BOOKINGS,
  GET_TRAINING_BOOKING,
  CREATE_TRAINING_BOOKING,
  UPDATE_TRAINING_BOOKING,
  DESTROY_TRAINING_BOOKING,
} from "./actions";

export function TrainingBookingReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_TRAINING_BOOKINGS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_TRAINING_BOOKING}_FULFILLED`:
    case `${CREATE_TRAINING_BOOKING}_FULFILLED`:
    case `${UPDATE_TRAINING_BOOKING}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_TRAINING_BOOKING}_FULFILLED`: {
      let newState = _.clone(state);
      const {
        meta: { id },
      } = action;
      _.unset(newState, id);
      return newState;
    }
    default:
      return state;
  }
}

// Move this to the reducer page
// import { TrainingBookingReducer } from "modules/training/bookings/reducer"

// training_bookings:TrainingBookingReducer,
